export default "__VITE_ASSET__ac1c7303__"